import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import type { AudienceListType } from '../../../../types.ts';
import { SegmentAlert } from '../expandableSections/segments/SegmentAlert.tsx';
import { HoverableItem } from '../HoverableItem.tsx';
import { getSegmentAlertProps } from '../utils/getSegmentAlertProps.ts';

type ParentNodeTitleProps = {
  namePath: string;
  type: AudienceListType;
  description?: string;
  showArchived: boolean;
  showExpired: boolean;
  showExpiresSoon: boolean;
  daysRemaining?: number;
};

export const ParentNodeTitle = ({
  namePath,
  type,
  description,
  showArchived,
  showExpired,
  showExpiresSoon,
  daysRemaining,
}: ParentNodeTitleProps) => {
  return (
    <HoverableItem type={type} readOnly>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          {description ? (
            <Tooltip title={description} placement="top">
              <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
                {namePath}
              </Typography>
            </Tooltip>
          ) : (
            <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
              {namePath}
            </Typography>
          )}
        </Box>

        <SegmentAlert {...getSegmentAlertProps(showArchived, showExpired, showExpiresSoon, daysRemaining)} />
      </Box>
    </HoverableItem>
  );
};
